import { useSyncExternalStore } from 'react';

export type NavMode = 'expanded' | 'rail' | 'drawer';

const createMediaQueryStore = (query: string) => ({
  subscribe: (onChange: () => void) => {
    const mediaQuery = window.matchMedia(query);
    mediaQuery.addEventListener('change', onChange);
    return () => mediaQuery.removeEventListener('change', onChange);
  },
  getSnapshot: () => window.matchMedia(query).matches,
});

const narrowViewport = createMediaQueryStore('(max-width: 1080px)');
const mobileViewport = createMediaQueryStore('(max-width: 767px)');

/**
 * Navigation layout: from 1081px the user picks the expanded sidebar or the icon rail, between 768px
 * and 1080px the rail is forced and the full menu opens in a drawer, from 767px down only the drawer.
 */
export const useNavMode = (collapsed: boolean) => {
  const isNarrow = useSyncExternalStore(narrowViewport.subscribe, narrowViewport.getSnapshot);
  const isMobile = useSyncExternalStore(mobileViewport.subscribe, mobileViewport.getSnapshot);
  const mode: NavMode = isMobile ? 'drawer' : isNarrow || collapsed ? 'rail' : 'expanded';

  return { mode, isRailForced: isNarrow };
};
